// extracted by mini-css-extract-plugin
export default {"body":"DeckSummaryPanel_body__8Eeev","type":"DeckSummaryPanel_type__CeKKz","types":"DeckSummaryPanel_types__dMUiq","dark":"DeckSummaryPanel_dark__685EH"};